import courseraPlusExperiments from 'bundles/epic/clients/courseraPlus';

export const previewCourseraPlusAnnualWithFreeTrialTestVariant = (isDefaultLandingPage: boolean) => {
  if (!isDefaultLandingPage) {
    return 'control';
  }

  return courseraPlusExperiments.preview('courseraPlusAnnualWith7dayFreeTrialTest');
};
